<ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="'spinner'">
        <div class="spinner" [style.width]="width" [style.height]="height"></div>
    </ng-container>
    <ng-container *ngSwitchCase="'strip'">
        <div class="strip animate" [style.width]="width" [style.height]="height"></div>
    </ng-container>
    <ng-container *ngSwitchDefault></ng-container>
</ng-container>